import { getTranslatedText } from "@/modules/cms/utils.server"

/**
 * 根据语言和 bannerImages 获取主图 url
 * @param lang 当前语言
 * @param bannerImages banner 图片数组
 * @returns 主图 url 或 undefined
 */
export function getMainImageByLang(
	lang: string,
	bannerImages?: Array<{
		type?: string
		link_trans?: Record<string, string>
		coverImage_trans?: Record<string, string>
	}>,
): string | undefined {
	if (!bannerImages || bannerImages.length === 0) return undefined
	const first = bannerImages[0]
	if (!first) return undefined
	if (first.type === "image" && first.link_trans) {
		// 使用 getTranslatedText 处理多语言
		return getTranslatedText(lang, first.link_trans) || undefined
	}
	if (first.type === "video" && first.coverImage_trans) {
		// 使用 getTranslatedText 处理多语言
		return getTranslatedText(lang, first.coverImage_trans) || undefined
	}
	return undefined
}

/**
 * 根据语言和 bannerImages 获取图片 url 数组
 * @param lang 当前语言
 * @param bannerImages banner 图片数组
 * @returns 图片 url 数组
 */
export function getImageUrlsFromBanner(
	lang: string,
	bannerImages?: Array<{
		type?: string
		link_trans?: Record<string, string>
		coverImage_trans?: Record<string, string>
	}>,
): string[] {
	if (!bannerImages || bannerImages.length === 0) return []

	return bannerImages
		.map((img) => {
			if (img.type === "image" && img.link_trans) {
				return getTranslatedText(lang, img.link_trans) || ""
			}
			if (img.type === "video" && img.coverImage_trans) {
				return getTranslatedText(lang, img.coverImage_trans) || ""
			}
			return ""
		})
		.filter(Boolean)
}

/**
 * 校验订单号格式
 * 订单号格式：以O开头，后面跟22位大写字母或数字
 * @param orderNumber 订单号
 * @returns 是否为有效的订单号格式
 */
export function validateOrderNumber(orderNumber: string): boolean {
	if (!orderNumber) return false

	// 正则表达式：O开头 + 22位大写字母或数字
	const orderNumberPattern = /^O[A-Z]{2}[A-Z0-9]{20}$/
	return orderNumberPattern.test(orderNumber)
}

/**
 * 校验旧订单号格式
 * 订单号格式：以O开头，如果第二个字符是数字则为旧订单，如果是字母则为新订单
 * @param orderNumber 订单号
 * @returns 是否为有效的旧订单号格式
 */
export function validateOldOrderNumber(orderNumber: string): boolean {
	if (!orderNumber || orderNumber.length < 2) return false

	// 检查第二个字符是否为数字（旧订单）或字母（新订单）
	return /^\d/.test(orderNumber[1])
}

export function isStoreGoOrder(orderNumber: string): boolean {
	return orderNumber?.startsWith("SP")
}

export function isBagSpuId(spuId: string): boolean {
	return spuId === process.env.NEXT_PUBLIC_BAG_SPU_ID
}
